const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-flipbook'] = {
        c: () => require('partner/modules/dobbies-flipbook/dobbies-flipbook.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-flipbook',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-flipbook'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-flipbook|dobbies-flipbook'] = {
                c: () => require('partner/modules/dobbies-flipbook/dobbies-flipbook.view.tsx'),
                cn: '__local__-__local__-dobbies-flipbook'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };